/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';

  
    const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "542")
  

// 接口文档



export interface API75602Req {
  
  /** 业务id */
  dataId?: string;
  /** 用户名称 */
  userName?: string;
};



export type API75602Res = {};


// 接口函数 75602 删除模型数据

export interface IUsePostAPI75602Return {
  /** 删除模型数据: 接口请求状态 */
  isAPI75602Loading: boolean;
  /** 删除模型数据: 接口请求返回数据 */
  dataAPI75602: API75602Res;
  /**  删除模型数据: 接口数据请求方法 */
  fetchAPI75602Data: (inputs: API75602Req, config?: YWRequestConfig) => Promise<API75602Res>;
  /** 删除模型数据: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI75602 = ():IUsePostAPI75602Return => {
  let isMount = true;
  const [isAPI75602Loading, setIsAPI75602Loading] = useState(false);
  const [dataAPI75602, setDataAPI75602] = useState<API75602Res>({} as API75602Res);
  const requestUrl = `${basePath}/yoaichat-web/chat/task/model/remove`;

  const fetchAPI75602Data = async (inputs: API75602Req, config?: YWRequestConfig): Promise<API75602Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API75602Req>) || {}) as API75602Req;
    
  
    if ( isMount ) {
      setIsAPI75602Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API75602Res>(`${basePath}/yoaichat-web/chat/task/model/remove`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI75602(res || {} as API75602Res);
        setIsAPI75602Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI75602Loading(false);
      }
      return false as unknown as API75602Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI75602Loading,
    dataAPI75602,
    fetchAPI75602Data,
    requestUrl,
  }
}

